import React from 'react';
import PropTypes from 'prop-types';

const Input = (props) => {
  const {
    id,
    type,
    onChange,
    value,
    disabled,
    className,
    placeholder,
    max,
    min,
  } = props;

  return (
    <input
      id={id}
      type={type}
      onChange={onChange}
      value={value}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      max={max}
      min={min}
    />
  );
};

export default Input;

Input.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
};

Input.defaultProps = {
  type: 'text',
  value: '',
  disabled: false,
  className: '',
  placeholder: '',
  max: null,
  min: null,
};
